import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-fahrzeugverwendungsbestimmung-list-view',
  imports: [],
  templateUrl: './fahrzeugverwendungsbestimmung.list-view.html',
  styleUrls: ['./fahrzeugverwendungsbestimmung.list-view.css'],
})
export class FahrzeugverwendungsbestimmungListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
